import { Listbox } from "@headlessui/react";
import { ChevronUpDownIcon, ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { stringToBlobUrl } from "common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PayoutTokenButton(props) {
  const {
    token,
    balance
  } = props;
  return /*#__PURE__*/_jsxs(Listbox.Button, {
    className: "relative w-full min-w-[120px] max-w-[250px] cursor-default rounded-md border h-10 border-gray-300 bg-white py-2 pl-3 text-left shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 text-xs md:text-sm",
    "data-testid": "payout-token-select",
    children: [/*#__PURE__*/_jsxs("span", {
      className: "flex items-center",
      children: [(token === null || token === void 0 ? void 0 : token.icon) && /*#__PURE__*/_jsx("img", {
        src: stringToBlobUrl(token.icon),
        alt: "Token Logo",
        className: "h-4 w-4 md:h-6 md:w-6 flex-shrink-0 rounded-full"
      }), /*#__PURE__*/_jsx("span", {
        className: `ml-2 block truncate text-sm ${token !== null && token !== void 0 && token.default ? "text-gray-500" : ""}`,
        children: token === null || token === void 0 ? void 0 : token.code
      }), /*#__PURE__*/_jsx("span", {
        className: `ml-2 text-xs md:text-sm hidden sm:inline-block ${props.balanceWarning ? "text-red-600" : "text-gray-500"}`,
        children: balance && /*#__PURE__*/_jsxs("div", {
          className: "flex items-center",
          children: [props.balanceWarning && /*#__PURE__*/_jsx(ExclamationCircleIcon, {
            className: "w-4 mr-1"
          }), /*#__PURE__*/_jsx("span", {
            className: "hidden md:inline",
            children: "Balance:"
          }), " ", balance.formattedAmount.toFixed(3)]
        })
      })]
    }), /*#__PURE__*/_jsx("span", {
      className: "pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2",
      children: /*#__PURE__*/_jsx(ChevronUpDownIcon, {
        className: "h-5 w-5 text-gray-400",
        "aria-hidden": "true"
      })
    })]
  });
}